import { render } from "./MenuNr2.vue?vue&type=template&id=17c9444c&scoped=true"
import script from "./MenuNr2.vue?vue&type=script&lang=js"
export * from "./MenuNr2.vue?vue&type=script&lang=js"

import "./MenuNr2.vue?vue&type=style&index=0&id=17c9444c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c9444c"]])

export default __exports__